import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lock-unlock-buttons',
  templateUrl: './lock-unlock.component.html',
  styleUrls: ['./lock-unlock.component.scss'],
})
export class LockUnlockComponent implements OnInit {
  @Input() showLockButton: boolean;
  @Input() showUnlockButton: boolean;
  @Input() isLocked?: boolean;
  @Input() formName: string;
  @Input() areButtonsDisabled: boolean;

  @Output() lockButtonClickedEvent = new EventEmitter<string>();
  @Output() unLockButtonClickedEvent = new EventEmitter<string>();

  ngOnInit(): void {}

  get showLockTooltip() {
    return !this.areButtonsDisabled || this.isLocked === true;
  }

  get showUnlockTooltip() {
    return !this.areButtonsDisabled || this.isLocked === false;
  }

  public lockClick(): void {
    if (!this.areButtonsDisabled) {
      this.isLocked = this.isLocked ? null : true;
      this.lockButtonClickedEvent.emit(this.formName);
    }
  }

  public unlockClick(): void {
    if (!this.areButtonsDisabled) {
      this.isLocked = this.isLocked === false ? null : false;
      this.unLockButtonClickedEvent.emit(this.formName);
    }
  }
}
